import { ArrowDownIcon, UpDownIcon } from "../icons";

export const SortIcon = ({ column }: { column: { getIsSorted: () => false | "asc" | "desc" } }) => {
  const sortDirection = column.getIsSorted();

  if (!sortDirection) {
    return <UpDownIcon />;
  }

  if (sortDirection === "asc") {
    return <ArrowDownIcon className="rotate-180 size-[9px]" />;
  }
  return <ArrowDownIcon className="size-[9px]" />;
};
